<script setup lang="ts">
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import type { BackgroundColorsPredefined, IntroData, VideoSlideData } from '~/@types/cms';
    import 'swiper/css';

    interface VideoSliderProps {
        videos: Array<VideoSlideData>;
        intro?: IntroData;
        background?: BackgroundColorsPredefined;
    }
    const props = defineProps<VideoSliderProps>();

    const { setMainSwiper, isBeginning, isEnd, swipeLeft, setControls, swipeRight, onSlideFocus } = useGallery();

    const md = screens('md');
</script>
<template>
    <mol-section
        :background="background"
        :intro="intro"
        center
        class="org-video-slider overflow-hidden">
        <div class="col-span-2 md:col-span-12">
            <nuxt-error-boundary @error="() => {}">
                <swiper
                    class="relative !overflow-visible"
                    :slides-per-view="1"
                    :breakpoints="{
                        [md]: {
                            slidesPerView: 2,
                        },
                    }"
                    :centered-slides="videos.length === 1"
                    :space-between="16"
                    @slide-change="setControls"
                    @swiper="setMainSwiper">
                    <swiper-slide
                        v-for="(slide, index) in props.videos"
                        :key="slide.id"
                        @focusin="() => onSlideFocus(index)">
                        <atm-video :data="slide.video" />
                        <div
                            v-if="slide.description"
                            class="swiper-no-swiping m-4 mb-0 text-center">
                            <renderer-html :content="woomTextFormat(slide.description)" />
                        </div>
                    </swiper-slide>
                    <mol-swiper-navigation
                        :is-beginning="isBeginning"
                        :is-end="isEnd"
                        :swipe-left="swipeLeft"
                        :swipe-right="swipeRight"
                        theme="wider" />
                </swiper>
            </nuxt-error-boundary>
        </div>
    </mol-section>
</template>
